<template>
  <validation-observer>
    <v-card
      flat
      max-width="480"
      class="neg-margin mx-auto px-9 px-md-0 pt-12 py-lg-0 responsive-bg"
    >
      <v-card-title
        primary-title
        class="step-title pa-0 pa-md-10 font-weight-bold mb-12 justify-md-center headline"
      >
        Step 2
        <abbr class="mobile-hypen">-</abbr>
        <span class="d-md-none">Tell us about yourself</span>
        <span class="d-none d-md-block">About you</span>
        <v-progress-linear indeterminate v-if="request.submitting" />
      </v-card-title>
      <div class="form-wrapper register">
        <div class="mb-5 mb-md-12">
          <CountryField
            name="country"
            rules="required"
            label="Country of Origin"
            item-value="alpha2Code"
            v-model="request.country_code"
          />
          <ValidationProvider
            name="diving_years"
            rules="integer"
            v-slot="{ errors }"
          >
            <v-text-field
              name="years_of_diving"
              :error-messages="errors"
              v-model="request.years_of_diving"
              label="Years of diving"
            />
          </ValidationProvider>
          <ValidationProvider
            name="diving_number"
            rules="integer"
            v-slot="{ errors }"
          >
            <v-text-field
              name="no_of_dives"
              :error-messages="errors"
              v-model="request.no_of_dives"
              label="Number of dives"
            />
          </ValidationProvider>
        </div>
        <v-btn
          depressed
          block
          large
          color="primary"
          class="mb-2 mb-md-8 font-weight-bold darken-3 title"
          @click.prevent="step(-1)"
          :disabled="request.submitting"
        >
          Back
        </v-btn>
        <v-btn
          depressed
          block
          large
          color="primary"
          class="mb-8 font-weight-bold title"
          @click.prevent="$emit('submit')"
          :loading="request.submitting"
          :disabled="request.submitting"
        >
          Submit
        </v-btn>
      </div>
    </v-card>
  </validation-observer>
</template>

<script>
import RegistrationRequest from '@request/Auth/RegistrationRequest';
import userCrud from '@mixins/userCrud';

export default {
  name: 'TouristRegistration',
  mixins: [userCrud],
  components: {
    CountryField: () => import('@components/utilities/CountryField'),
  },
  props: {
    request: {
      type: RegistrationRequest,
      required: true,
      default: () => {},
    },
  },
  methods: {
    async step(step = 1) {
      if (step < 1) {
        if (await this.request.validate()) {
          this.$emit('step', step);
        }
      }
    },
  },
  mounted() {
    this.getTrips();
  },
};
</script>

<style scoped></style>
